import { useEffect, useMemo } from "react";
import toast from "react-hot-toast";

export default function CameraFileInput({
  id,
  label,
  value,
  multiple = false,
  accept = "image/jpeg,image/png,application/pdf",
  onChange
}) {
  const files = useMemo(() => (Array.isArray(value) ? value.filter(Boolean) : []), [value]);
  const previews = useMemo(() => (
    files.map((file) => ({
      name: file.name,
      url: URL.createObjectURL(file),
      isImage: file.type.startsWith("image/"),
      isPdf: file.type === "application/pdf"
    }))
  ), [files]);

  useEffect(() => () => {
    previews.forEach((preview) => URL.revokeObjectURL(preview.url));
  }, [previews]);

  const handleFiles = (event) => {
    const selected = Array.from(event.target.files || []);
    const allowedFiles = selected.filter((file) => (
      ["image/jpeg", "image/png", "application/pdf"].includes(file.type)
    ));

    if (selected.length !== allowedFiles.length) {
      toast.error("Gebruik enkel JPG, PNG of PDF bestanden.");
    }

    onChange(multiple ? allowedFiles : allowedFiles[0] || null);
    event.target.value = "";
  };

  const removeFile = (index) => {
    if (multiple) {
      onChange(files.filter((_, fileIndex) => fileIndex !== index));
      return;
    }

    onChange(null);
  };

  return (
    <div className={`document-upload-card${files.length ? " complete" : ""}`}>
      <div className="document-upload-copy">
        <span className="field-label">{label}</span>
        <strong>{files.length ? "Foto toegevoegd" : "Nog niet toegevoegd"}</strong>
        <span className={`checkout-photo-status${files.length ? " complete" : ""}`}>
          {files.length ? `${files.length} foto${files.length === 1 ? "" : "'s"}` : "Verplicht"}
        </span>
      </div>

      <div className="document-upload-preview-grid">
        {previews.length ? previews.map((preview, index) => (
          <div key={`${preview.name}-${preview.url}`} className="document-upload-preview">
            {preview.isImage ? (
              <img src={preview.url} alt={preview.name || label} />
            ) : (
              <div className="checkout-photo-placeholder">{preview.isPdf ? "PDF-document" : "Bestand"}</div>
            )}
            <button type="button" className="document-remove-button" onClick={() => removeFile(index)}>
              Verwijderen
            </button>
          </div>
        )) : (
          <div className="checkout-photo-placeholder">Geen foto</div>
        )}
      </div>

      <input
        id={id}
        className="checkout-file-input"
        type="file"
        accept={accept}
        capture="environment"
        multiple={multiple}
        onChange={handleFiles}
      />
      <label className="button checkout-camera-button" htmlFor={id}>
        {files.length ? "Foto vervangen" : "Foto nemen"}
      </label>
      <p className="row-meta checkout-photo-hint">Op gsm opent dit de camera waar ondersteund. Galerij upload blijft mogelijk.</p>
    </div>
  );
}
